import { FC, useEffect, useRef, useState } from 'react'
import { IManualSuscriptionContractSummary } from '../../../../common/interfaces'
import { CONTRACT_TYPE_BADGE } from '../utils/contractTypeBadge'
import { getContractDisplayName } from '../utils/getContractDisplayName'

interface IProps {
  contracts: IManualSuscriptionContractSummary[]
  value: number | ''
  onChange: (index: number | '') => void
}

interface IContractBadgeProps {
  contract: IManualSuscriptionContractSummary
}

const ContractBadge: FC<IContractBadgeProps> = ({ contract }) => {
  const badge = CONTRACT_TYPE_BADGE[contract.tipoContrato.code]

  return (
    <span
      className='contract-select-badge badge rounded me-2'
      style={{ backgroundColor: badge.bg, color: badge.color }}
    >
      {contract.tipoContrato.label}
    </span>
  )
}

export const ContractSelect: FC<IProps> = ({ contracts, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const selectedContract = value !== '' ? contracts[value] : undefined

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleSelect = (index: number) => {
    onChange(index)
    setIsOpen(false)
  }

  return (
    <div className='col-lg-6 mb-7'>
      <label htmlFor='contract' className='text-muted fs-6 mb-2'>
        Tipo de contrato
      </label>
      <div className='position-relative' ref={containerRef}>
        <button
          id='contract'
          type='button'
          className='selectForm contract-select-toggle contract-select-button d-flex align-items-center justify-content-between'
          onClick={() => setIsOpen((prev) => !prev)}
          aria-haspopup='listbox'
          aria-expanded={isOpen}
        >
          {selectedContract ? (
            <span className='d-flex align-items-center text-truncate'>
              <ContractBadge contract={selectedContract} />
              <span className='text-truncate'>{getContractDisplayName(selectedContract)}</span>
            </span>
          ) : (
            <span>Seleccione</span>
          )}
          <i className='bi bi-chevron-down fs-7' />
        </button>

        {isOpen && (
          <div
            className='contract-select-panel position-absolute w-100 bg-white rounded shadow-sm'
            role='listbox'
          >
            {contracts.map((contract, index) => (
              <div
                key={contract.codParticipe}
                role='option'
                aria-selected={value === index}
                className='contract-select-option d-flex align-items-center px-3 py-2'
                onClick={() => handleSelect(index)}
              >
                <ContractBadge contract={contract} />
                <span>{getContractDisplayName(contract)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
